// const BASE_URL = 'http://localhost:4000';
//const BASE_URL = 'https://rimagro.onrender.com';
const BASE_URL = 'https://www.rimagrobackend.trackerdev.com.ar';
export const USER_LOGIN_URL = BASE_URL + '/api/users/login';
export const USERS_URL = BASE_URL + '/api/users';
export const TANKS_URL = BASE_URL + '/api/tanks';
export const FUEL_URL = BASE_URL + '/api/fuels';
export const VEHICLE_URL = BASE_URL + '/api/vehicles';
export const CHARGE_URL = BASE_URL + '/api/charges';
export const VOUCHER_URL = BASE_URL + '/api/vouchers';
export const DISCHARGE_URL = BASE_URL + '/api/discharges';
export const PUMP_URL = BASE_URL + '/api/pumps';

